import { useLocation } from '@remix-run/react';

export function useActionUrlWithOrigin(actionPath: string, paramName = 'from') {
    const { pathname, search } = useLocation();

    const u = new URL(actionPath, 'http://remix.local');
    u.searchParams.set(paramName, `${pathname}${search}`);

    return `${u.pathname}${u.search}`;
}
